<script setup>
import LottieIcon from '../../components/LottieIcon.vue';

const props = defineProps({
    authorbox: {
        type: Object,
        required: true,
    },
    user: {
        type: Object,
        required: true,
    },
});

import lottieFinanzjournalismus from '../../components/icons/lottie-finanzjournalismus.json';
import lottieZielzonen from '../../components/icons/lottie-praezise-zielzonen.json';
</script>

<template>
    <div
        class="group hover:bg-blue-light border border-white hover:border-blue overflow-hidden transition-all ease-in-out duration-300 mt-2 w-full p-2 rounded-md hover:shadow-md">
        <router-link :to="'/hkcmnews/?authors=' + user.id" class="flex flex-col lg:flex-row lg:items-center gap-4">
            <div>
                <img class="rounded-full object-cover object-top w-20 h-20" :src="authorbox.portrait"
                    :alt="authorbox.author" />
            </div>
            <div>
                <div class="uppercase tracking-wide text-sm font-semibold">
                    <div>{{ authorbox.author }}</div>
                </div>
                <div class="flex flex-col lg:flex-row gap-4 mt-2">
                    <div>
                        <div class="flex gap-0 items-center">
                            <LottieIcon class="w-8 h-8" :animation-data="lottieFinanzjournalismus" :loop-delay="5200" />
                            <div class="font-semibold">{{ authorbox.publishedArticles }}</div>
                        </div>
                        <div class="text-blue-dark mt-1">
                            <div class="text-xxs break-words">{{ $t('published_articles') }}</div>
                        </div>
                    </div>
                    <div v-if="authorbox.coreTopics.length > 0">
                        <div class="flex gap-0 items-center text-blue-dark">
                            <LottieIcon class="w-8 h-8" :animation-data="lottieZielzonen" :loop-delay="5000" />
                            <div class="font-semibold">{{ $t('core_topics') }}</div>
                        </div>
                        <div class="flex flex-wrap items-center gap-3">
                            <div v-for="(topic, index) in authorbox.coreTopics" :key="index"
                                class="rounded-full transition-all ease-in-out group-hover:bg-blue bg-blue-light flex items-center p-1 py-0.5 gap-2 px-2">
                                <span
                                    class="transition-all ease-in-out group-hover:bg-blue-light bg-blue w-1.5 h-1.5 rounded-full block"></span>
                                <span class="uppercase text-xxs group-hover:text-white">{{ topic }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </router-link>
    </div>
</template>
